import React from "react";
import {
  Spin,
  Divider,
  Row,
  Col,
  Card,
  Tooltip,
  Progress
} from "antd";
import global from "../../../common/utility/global";
import Header from "../../../components/Header";
import Filters from "./Filters";
import anioMock from '../../../common/mock/anioMock';
import mesMock from '../../../common/mock/mesMock';
import cuentasPagarService from '../../../service/tesoreria/cuentasPagar';

import GraficoBarGroup from "./GraficoBarGroup";
import GraficoPie from "./GraficoPie";

export default class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      anios: anioMock.values,
      meses: mesMock.values,
      filter: {
        anioInicio: global.fetchCurrentYear(true),
        mesInicio: global.fetchCurrentMonth(true),
        anioFin: global.fetchCurrentYear(),
        mesFin: global.fetchCurrentMonth()
      },
      totalVentas: {
        PEN: 0,
        USD: 0
      },
      totalVencidos: {
        PEN: 0,
        USD: 0
      },
      totalCobrar: {
        PEN: 0,
        USD: 0
      },

      graficoBarraCobranza: {
        pen: [],
        usd: [],
        categories: [],
      },
      graficoPieCobranza: {
        series: [],
        labels: []
      },
    };
  }

  handleChange = (property, value) => {
    const filter = { ...this.state.filter, [property]: value };
    this.setState({ filter });
  };

  handleClearFilters = () => {

    this.setState({
      fechaInicioStr: global.fetchCurrentDateStr(true),
      fechaFinStr: global.fetchCurrentDateStr(),
    });
  };

  handleGenerateReport = async (filter) => {
    this.handleGenerateCobranza(filter);

    this.handleGenerateTotal(filter);
    this.handleGenerateVencidos(filter);

  }

  handleGenerateCobranza = async (filter) => {

    this.setState({
      loading: true,
    });
    const response = await cuentasPagarService.dashboardDeuda(filter);
    if (response !== undefined) {

      let data = response;

      const clientesSet = new Set(data.map(d => d.nombre));
      const clientes = [...clientesSet];
      debugger
      const penData = clientes.map(cliente => {
        const item = data.find(d => d.nombre === cliente && d.moneda === 'PEN');
        return item ? item.total : 0;
      });

      const usdData = clientes.map(cliente => {
        const item = data.find(d => d.nombre === cliente && d.moneda === 'USD');
        return item ? item.total : 0;
      });

      const { series, labels } = this.getSeriesFromData(data);


      const sum1 = penData.reduce((acc, value) => acc + value, 0);
      const sum2 = usdData.reduce((acc, value) => acc + value, 0);

      this.setState({
        graficoBarraCobranza: {
          pen: penData,
          usd: usdData,
          categories: clientes,
        },
        graficoPieCobranza: {
          series: series,
          labels: labels
        },

        totalCobrar: {
          PEN: sum1,
          USD: sum2
        },

        loading: false
      });

    }

  };


  handleGenerateTotal = async (filter) => {

    this.setState({
      loading: true,
    });
    const response = await cuentasPagarService.dashboardTotal(filter);
    if (response !== undefined) {
      if (response.length == 0) {

        this.setState({
          totalVentas: {
            PEN: 0,
            USD: 0
          },
          loading: false
        });
      } else {
        this.setState({
          totalVentas: {
            PEN: response[0].sumaSoles,
            USD: response[0].sumaDolares
          },
          loading: false
        });
      }


    }

  };

  handleGenerateVencidos = async (filter) => {

    this.setState({
      loading: true,
    });
    const response = await cuentasPagarService.dashboardTotalVencidos(filter);
    if (response !== undefined) {

      if (response.length == 0) {
        this.setState({
          totalVencidos: {
            PEN: 0,
            USD: 0
          },
          loading: false
        });
      } else {
        this.setState({
          totalVencidos: {
            PEN: response[0].sumaSoles,
            USD: response[0].sumaDolares
          },
          loading: false
        });
      }



    }

  };


  getSeriesFromData = (data) => {
    const totales = data.reduce(
      (acc, item) => {
        if (item.moneda === 'PEN') {
          acc.PEN += item.total;
        } else if (item.moneda === 'USD') {
          acc.USD += item.total;
        }
        return acc;
      },
      { PEN: 0, USD: 0 }
    );

    return {
      series: [totales.PEN, totales.USD],
      labels: ['PEN', 'USD']
    };
  };


  async componentDidMount() {
    await this.handleGenerateReport(this.state.filter);
    this.setState({
      loading: false,
    });
  }

  render() {
    return (
      <div>
        <Header
          title="Dashboard General de Cuentas Por Pagar"
          onClearFilters={this.handleClearFilters}
          onSearch={() => this.handleGenerateReport(this.state.filter)}
        />
        <Divider />
        <Filters filter={this.state.filter} anios={this.state.anios} meses={this.state.meses} onChange={this.handleChange} />
        <Spin tip="Cargando..." size="large" spinning={this.state.loading}>
          <Divider className="mb-20" />

   {/*        <Row gutter={50} style={{ padding: '10px' }}>
            <Col xs={24} sm={12} md={6} lg={6} style={{ padding: '10px' }}>
              <Card title="COMPRAS" style={{ backgroundColor: '#52c41a', fontSize: '30px', color: 'white', borderRadius: 10 }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span>S/ {this.state.totalVentas.PEN}</span>
                  <span>$ {this.state.totalVentas.USD}</span>
                </div>
              </Card>

            </Col>

            <Col xs={24} sm={12} md={6} lg={6} style={{ padding: '10px' }}>


              <Card title="A PAGAR" style={{ backgroundColor: '#00aae4', fontSize: '30px', color: 'white', borderRadius: 10 }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span>S/ {this.state.totalCobrar.PEN}</span>
                  <span>$ {this.state.totalCobrar.USD}</span>
                </div>
              </Card>

            </Col>

            <Col xs={24} sm={12} md={6} lg={6} style={{ padding: '10px' }}>

              <Card title="VENCIDO" style={{ backgroundColor: 'red', fontSize: '30px', color: 'white', borderRadius: 10 }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span>S/ {this.state.totalVencidos.PEN}</span>
                  <span>$ {this.state.totalVencidos.USD}</span>
                </div>
              </Card>

            </Col>

            <Col xs={24} sm={12} md={6} lg={6} style={{ padding: '10px' }}>
              <Card
                title={<span style={{ fontWeight: 'bold' }}>% VENCIDO</span>}
                style={{ backgroundColor: 'white', color: 'white', borderRadius: '10px', padding: '10px' }}
                bodyStyle={{ padding: '10px 10px' }}
              >
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(2, 1fr)',
                  gap: '20px',
                  alignItems: 'center',
                  justifyItems: 'center'
                }}>
                  <Tooltip title={"% " + ((this.state.totalVencidos.PEN / this.state.totalCobrar.PEN) * 100) + " PEN"}>
                    <Progress
                      percent={(this.state.totalVencidos.PEN / this.state.totalCobrar.PEN) * 100}
                      type="dashboard"
                      status="active"
                      width={90}
                      strokeWidth={8}
                      strokeColor="#ff4d4f"

                    />
                  </Tooltip>

                  <Tooltip title={"% " + ((this.state.totalVencidos.USD / this.state.totalCobrar.USD) * 100) + " USD"}>
                    <Progress
                      percent={(this.state.totalVencidos.USD / this.state.totalCobrar.USD) * 100}
                      type="dashboard"
                      status="active"
                      width={90}
                      strokeWidth={8}
                    />
                  </Tooltip>
                </div>




              </Card>
            </Col>

          </Row> */}
          <Divider className="mb-20" />

          <Row gutter={50}>
            <Col className="gutter-row" sm={12} md={12} lg={12}>
              <GraficoPie
                title={"Deuda Total Por Proveedor"}
                series={this.state.graficoPieCobranza.series}
                labels={this.state.graficoPieCobranza.labels}
              />
            </Col>
            <Col className="gutter-row" sm={24} md={12} lg={12}>
              <GraficoBarGroup
                title={"Deuda Total a Proveedor"}
                categories={this.state.graficoBarraCobranza.categories}
                series={[
                  { name: 'PEN', data: this.state.graficoBarraCobranza.pen },
                  { name: 'USD', data: this.state.graficoBarraCobranza.usd }
                ]}
              />
            </Col>
          </Row>


        </Spin>
      </div>
    );
  }
}
